// extracted by mini-css-extract-plugin
module.exports = {"root":"_ec32ed","imageContainer":"_f877a5","chip":"_496726","category":"_454f6f","title":"_02b9b6","content":"_41f734"};